//import { InformationLog } from '../../components/Shared/ServerLogging';
import { useEffect, useState } from "react";
import { useHistory } from "react-router"
import { isTokenExpired } from "../api/localstorage";

export const useLogin = () =>
{
    const [loggedIn, setLoggedIn] = useState({})
    const [init, setInit] = useState();
    const history = useHistory();
    const path = history.location.pathname

    useEffect(() =>{
        var data = localStorage.getItem('account');
        try {
            data = JSON.parse(data);
            if(!data) data = {};
        }catch(err){
            data = {}
        }

        if (isTokenExpired(data.token)) {
            data = {};
        }

        setLoggedIn(data);
        setInit(true);
    }, [path])

    return {loading: init ? false : true, account: loggedIn};
}